import { useSelector } from "react-redux";
import { filtersConfigTemplates } from "../../../enums/filtersType";

const useDiscoveryFilterTemplates = () => {
    const isStudent = useSelector((state) => state.auth.isStudent);
    return filtersConfigTemplates.filter((t) => !t.teacherOnly || isStudent === false);
};

export default useDiscoveryFilterTemplates;
